import React, { useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { makeStyles, withStyles } from "@material-ui/core/styles";
import { Button, List, ListItem, ListItemAvatar, Dialog, Typography } from "@material-ui/core";

import AvatarIcon from "./Icons/avatar";

//store
import * as actions from "../../store/actions/actionIndex";
// uitility function
import { maskedNumber, decryptPhoneNumber } from "../../helpers/utility";

const styles = {
	DataTable: {
		margin: "-32px",
		"MuiTableRow-head": {
			th: {
				backgroundColor: "#f6f7f8",
			},
		},
	},
	callButton: {
		color: "#40F01A",
		height: "27px",
		width: "75px",
		borderColor: "#40F01A",
		textTransform: "capitalize",
		textAlign: "center",
	},
	Remarks: {
		color: "red",
	},
};

const useStyles = makeStyles({
	dialog: {
		// position:"absolute",
		// padding:"none",
		width: "400px",
		margin: "0 auto",
	},
	avatar: {
		textAlign: "center",
		alignItems: "center",
		position: "absolute",
		// right:"80px",
		// margin:"10px",
		paddingInlineStart: "27px",
		marginTop: "30px",
	},
	dialogTital: {
		fontSize: "0.8rem",
		textAlign: "center",
		paddingTop: "20px",
		color: "#686D88",
	},
	callerName: {
		fontSize: "1rem",
		textAlign: "center",
		color: "#526FEB",
		paddingBottom: "40px",
		paddingTop: "0px",
	},
	titleWords: {
		fontSize: "0.8rem",
		textAlign: "center",
		width: "90%",
		paddingTop: "55px",
		paddingInlineStart: "38px",
		color: "#686D88",
	},
	callButton: {
		insetInlineStart: "100px",
		marginTop: "18px",
		marginBottom: "30px",
		backgroundColor: "#FF3B30",
		color: "white",
		textTransform: "capitalize",
		height: "35px",
		width: "132px",
	},
	TooltipBox: {
		display: "flex",
		flexFlow: "row",
	},
	TooltipText: {
		paddingInlineStart: "10px",
		display: "flex",
	},
	DotClass: {
		marginTop: "10px",
		paddingInlineEnd: "4px",
	},
});

function SimpleDialog(props) {
	const classes = useStyles();
	const { handleClose, selectedValue, open, mode } = props;
	const handleClick = () => {
		props.onAgentDisconnect(props.agentId);
	};
	/*if (props.agentState !== "CALL_PROGRESS") {
		onClose(false);
	}*/
	React.useEffect(() => {
		if (props.agentState !== "CALL_PROGRESS") {
			//handleClose(true);
		}
	}, [props.agentState, handleClose]);

useEffect(() => {
  const handleDialogChange = () => {
    if (window.dialogState && window.dialogState.open === false) {
      handleClose();
    }
  };

  window.addEventListener("dialogStateChanged", handleDialogChange);
  return () => window.removeEventListener("dialogStateChanged", handleDialogChange);
}, [handleClose]);
	return (
		<Dialog className={classes.dialog} fullWidth onClose={() => handleClose()} aria-labelledby="simple-dialog-title" open={open}>
			<List>
				<Typography className={classes.dialogTital}>Connecting...</Typography>
				<Typography className={classes.dialogTital} align="center" style={{whiteSpace:"pre-wrap",overflowWrap:"break-word",paddingInlineEnd: "10px",paddingInlineStart: "10px"}}>{selectedValue.name}</Typography>
				{mode === "uniqueDial" 
				? 
				<Typography className={classes.callerName}>{props.facilityConf.enable_number_mask ? (props.facilityConf.enable_number_mask === "0" ? selectedValue.phone : maskedNumber(selectedValue.phone, props.facilityConf.mask_start_pos, props.facilityConf.mask_end_pos)) : selectedValue.phone}
				</Typography>:
				<Typography className={classes.callerName}>{props.facilityConf.enable_number_mask ? (props.facilityConf.enable_number_mask === "0" ? decryptPhoneNumber(selectedValue.phone) : maskedNumber(selectedValue.phone, props.facilityConf.mask_start_pos, props.facilityConf.mask_end_pos)) : decryptPhoneNumber(selectedValue.phone)}
				</Typography>
              }
				<ListItem>
					<ListItemAvatar className={classes.avatar}>
						<AvatarIcon />
					</ListItemAvatar>
				</ListItem>
				<Typography className={classes.titleWords}>Call in Progress</Typography>
				<Button variant="contained" className={classes.callButton} onClick={handleClick}>
					Disconnect
				</Button>
			</List>
		</Dialog>
	);
}

SimpleDialog.propTypes = {
	handleClose: PropTypes.func.isRequired,
	open: PropTypes.bool.isRequired,
	selectedValue: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
	return {
		error: state.agentDisconnect.error,
		loading: state.agentDisconnect.loading,
		facilityConf: state.agentConfig.facilityConf,
		agentState: state.agentData.agentState,
		agentId: state.agentData.agentId,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		onAgentDisconnect: (agentId) => dispatch(actions.agentDisconnect(agentId)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(SimpleDialog));